import { Loader } from '@progress/kendo-react-indicators';
import "./loadercontainer.css";

export default function LoaderContainer() {
  return (
    <div
      className="k-d-flex k-justify-content-center k-align-items-center k-w-full k-h-full"
    >
      <Loader
        className="loader"
        size={'large'}
        type={'infinite-spinner'}
      />
    </div>
  );
}

